document.addEventListener('change', (event) => {
  if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
});

document.addEventListener('click', (event) => {
  const menu = document.querySelector('.mobile-nav[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('details[open]').forEach((item) => { item.open = false; });
});

document.querySelectorAll('[data-hero]').forEach((hero) => {
  const slides = [...hero.querySelectorAll('[data-hero-slide]')];
  const buttons = [...hero.querySelectorAll('[data-hero-select]')];
  hero.classList.add('is-hero-enhanced');
  buttons.forEach((button, selectedIndex) => {
    button.addEventListener('click', () => {
      slides.forEach((slide, index) => { slide.hidden = index !== selectedIndex; });
      buttons.forEach((control, index) => { control.setAttribute('aria-pressed', String(index === selectedIndex)); });
    });
  });
});
